import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { Grid } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import FormTextField from '../../../Form/FormTextField';

const EntityAddressesPage = function EntityAddressesPage({
  errors, //if there are errors, the object containing fields keyNames and their error value
  data, //data at opening dialog (backend data)
  formData, //data inserted in the form
  contact = false,
  edit = false,
}) {
  const intl = useIntl();
  const { reset } = useFormContext();

  useEffect(() => {
    if (typeof data !== 'boolean' && Object.keys(data || {}).length > 0) {
      reset({
        ...(data ?? {}),
        ...(formData ?? {}),
      });
    }
  }, [data]);

  return (
    <Grid container spacing={2}>
      <Grid size={{ md: 4, sm: 6, xs: 12 }}>
        <FormTextField allUpperCase name="address" error={errors?.address} />
      </Grid>
      <Grid size={{ md: 4, sm: 6, xs: 12 }}>
        <FormTextField allUpperCase name="city" error={errors?.city} />
      </Grid>
      <Grid size={{ md: 4, sm: 6, xs: 12 }}>
        <FormTextField
          name="state"
          allUpperCase
          error={errors?.state}
          maxCharacters={2}
        />
      </Grid>
      <Grid size={{ md: 4, sm: 6, xs: 12 }}>
        <FormTextField name="country" allUpperCase error={errors?.country} />
      </Grid>
      <Grid size={{ md: 4, sm: 6, xs: 12 }}>
        <FormTextField
          name="zipCode"
          error={errors?.zipCode}
          validateCallback={(zCode) =>
            !isNaN(zCode) || intl.messages.NOLETTERS_VALIDATION
          }
        />
      </Grid>
      {!(edit && contact) && (
        <>
          <Grid size={{ md: 4, sm: 6, xs: 12 }}>
            <FormTextField
              name="email"
              error={errors?.email}
              validateCallback={(value) =>
                !value || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
                  ? undefined
                  : intl.messages.INVALID_EMAIL_ADDRESS
              }
            />
          </Grid>
          <Grid size={{ md: 4, sm: 6, xs: 12 }}>
            <FormTextField
              defaultValue={data?.mobilePhoneNumber}
              name="mobilePhoneNumber"
              error={errors?.mobilePhoneNumber}
              validateCallback={(phoneNumber) =>
                !isNaN(phoneNumber) && phoneNumber !== '+39'
                  ? true
                  : intl.messages.INVALID_PHONE_NUMBER
              }
            />
          </Grid>
          <Grid size={{ md: 4, sm: 6, xs: 12 }}>
            <FormTextField
              name="landlinePhoneNumber"
              error={errors?.landlinePhoneNumber}
              validateCallback={(phoneNumber) =>
                !isNaN(phoneNumber) && phoneNumber !== '+39'
                  ? true
                  : intl.messages.INVALID_PHONE_NUMBER
              }
            />
          </Grid>
        </>
      )}
      <Grid size={{ md: 4, sm: 6, xs: 12 }}>
        <FormTextField name="webSite" error={errors?.webSite} />
      </Grid>
      <Grid size={{ md: 4, sm: 6, xs: 12 }}>
        <FormTextField
          name="linkedInProfile"
          label={intl.messages.LINKEDINLINK}
          error={errors?.linkedInProfile}
        />
      </Grid>
      <Grid size={{ md: 4, sm: 6, xs: 12 }}>
        <FormTextField
          name="facebookProfile"
          label={intl.messages.FACEBOOKLINK}
          error={errors?.facebookProfile}
        />
      </Grid>
      <Grid size={{ md: 4, sm: 6, xs: 12 }}>
        <FormTextField
          name="twitterProfile"
          label={intl.messages.TWITTERLINK}
          error={errors?.twitterProfile}
        />
      </Grid>
    </Grid>
  );
};

export default EntityAddressesPage;
